import { useState } from "react";
import { Routes, Route } from "react-router";
import Home from "./Components/Home/Home";
import ItemDetail from "./Components/ItemDetail/ItemDetail";
import Footer from "./Components/Footer/Footer";
import Cart from "./Components/Cart/Cart";
import Products from "./Components/Products/Products";
import Login from "./Components/Login/Login";
import Register from "./Components/Register/Register";
import Creators from "./Components/Creators/Creators";
import Thanks from "./Components/Thanks/Thanks";
import AboutThisProject from "./Components/AboutThisProject/AboutThisProject";
import PageNotFound from "./Components/PageNotFound/PageNotFound";
import Contact from "./Components/Contact/Contact";
import Profile from "./Components/profile/Profile";
import OrderHistory from "./Components/OrderHistory/OrderHistory";
import WelcomeModal from "./Components/welcomeModal/WelcomeModal";
import ProtectedRoutes from "./Components/protectedRoutes/ProtectedRoutes";
import NavBar from "./Components/Navbar/Navbar";

function App() {
  const [modalShow, setModalShow] = useState(true);
  return (
    <>
      <AboutThisProject />
      <NavBar />
      <div className="appContainer">
        <WelcomeModal show={modalShow} onHide={() => setModalShow(false)} />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<Creators />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/:slug" element={<ItemDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/contact" element={<Contact />} />
          <Route element={<ProtectedRoutes />}>
            <Route path="/checkout" element={<Cart />} />
            <Route path="/thanks" element={<Thanks />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/order-history" element={<OrderHistory />} />
          </Route>
        </Routes>
      </div>
      <Footer />
    </>
  );
}

export default App;
